/* eslint-disable no-unused-vars */
import { QuestionFormField, QuestionFormFieldType } from './questionFormField'

/**
 * Creates an instance of Base64FileUploadField.
 * @typedef {Object} Base64FileUploadFieldType
 * @property {string[]} allowedFileTypes
 *
 * @typedef {QuestionFormFieldType & Base64FileUploadFieldType} Base64FileUploadFieldExtendType
 */

/**
 * Represents a base 64 upload form field.
 * @class
 */
export class Base64FileUploadField extends QuestionFormField {
  /**
   * Create a new Base64FileUploadField.
   * @param {Base64FileUploadFieldExtendType} params
   */
  constructor(params) {
    super(params)
    this.allowedFileTypes = params.allowedFileTypes
  }
}
